import { fork } from 'redux-saga/effects';
import { saga as toastrSaga } from 'components/common/toastr';
import apiSaga from './api-saga';
import appSaga from './app-saga';
import notificationsSaga from './notifications-saga';
import toastSaga from './toastSaga';

export default function* rootSaga() {
  yield fork(apiSaga);
  yield fork(appSaga);
  yield fork(notificationsSaga);
  yield fork(toastrSaga);
  yield fork(toastSaga);
}
